import {
  OpensearchSearchRequestOpenSearchDataTypeEnum,
  OpensearchSearchResponseListObject,
  OpensearchSearchRequest,
  ColumnConfiguration,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';
import qs from 'qs';
export interface AutoColumnConfig {
  column: string;
  columnType: string;
  isVisible: boolean;
  isSortable: boolean;
  size?: number;
  maxSize?: number;
}

export const getOpensearchTableConfig = async (
  dataType: OpensearchSearchRequestOpenSearchDataTypeEnum,
): Promise<ColumnConfiguration[]> => {
  return httpClient.get(`opensearch/${dataType}/configuration`).json();
};

export const getOpensearchTableData = async (
  request: OpensearchSearchRequest,
  signal?: AbortSignal,
): Promise<OpensearchSearchResponseListObject> => {
  return httpClient
    .get(`opensearch`, {
      searchParams: qs.stringify(request, { allowDots: true }),
      signal,
    })
    .json();
};
